import { render } from "./IndividualItemList.vue?vue&type=template&id=28335aa8&scoped=true"
import script from "./IndividualItemList.vue?vue&type=script&lang=js"
export * from "./IndividualItemList.vue?vue&type=script&lang=js"

import "./IndividualItemList.vue?vue&type=style&index=0&id=28335aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28335aa8"]])

export default __exports__